import { render, staticRenderFns } from "./demanYaoqing.vue?vue&type=template&id=62832f55&scoped=true"
import script from "./demanYaoqing.vue?vue&type=script&lang=js"
export * from "./demanYaoqing.vue?vue&type=script&lang=js"
import style0 from "./demanYaoqing.vue?vue&type=style&index=0&id=62832f55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62832f55",
  null
  
)

export default component.exports